<template>
	<BaseChart :option="finalOption" />
</template>

<script>
	export default {
		name: 'LineChart',
		props: {
			xData: {
				type: Array,
				default: () => [],
			},
			barData: {
				type: Array,
				default: () => [],
			},
			option: Object,
			color: {
				type: String,
				default: '#4080FF',
			},
		},

		computed: {
			baseOption() {
				return {
					color: this.color,
					grid: {
						bottom: '18%',
						right: '5%',
						top: '5%',
						left: '5%',
					},
					tooltip: {
						trigger: 'axis',
						formatter: value => {
							return `${value[0].name} <br/>${value[0].marker} ${value[0].value} 万元`;
						},
					},
					legend: {
						show: false,
						bottom: '2%',
						itemWidth: 14,
						itemGap: 60,
					},
					xAxis: [
						{
							type: 'category',
							data: this.xData,
							splitLine: {
								show: true,
								lineStyle: { type: 'dashed' },
							},
						},
					],
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: { type: 'dashed' },
						},
					},

					series: [
						{
							name: this.name,
							type: 'bar',
							barWidth: '20%',
							data: this.barData,
						},
					],
				};
			},

			finalOption() {
				return this.merge(this.baseOption, this.option);
			},
		},

		methods: {
			merge(base, custom) {
				if (!custom) return base;

				return {
					...base,
					...custom,
					legend: {
						...base.legend,
						...(custom.legend || {}),
					},
					xAxis: base.xAxis.map((item, i) => ({
						...item,
						...(custom.xAxis && custom.xAxis[i]),
					})),
					yAxis: base.yAxis.map((item, i) => ({
						...item,
						...(custom.yAxis && custom.yAxis[i]),
					})),
					series: base.series.map((item, i) => ({
						...item,
						...(custom.series && custom.series[i]),
					})),
				};
			},
		},
	};
</script>
